import { useContext, useReducer, useState } from "react";

import { ApiHelper } from "@datanac/datanac-api-toolkit/dist/api-helper";
import { CloseOutlined, SaveOutlined } from "@mui/icons-material";
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Stack } from "@mui/material";
import { _sessionManager } from "api/ApiHelper";
import { AppContext } from "App";
import { propUpdateReducer } from "components/Core/propUpdateReducer";
import { StatefulControlledTextField } from "components/Core/StatefulControlledTextField";
import { useSnackbar } from "notistack";

import { getErrorMessage } from "./helpers";

export const ProducerPolicyDialog = ({
  currentPolicy,

  onClose,
}) => {
  const { globalState } = useContext(AppContext);

  const { enqueueSnackbar } = useSnackbar();

  // --- --- ---

  const isValid = () => {
    return Boolean(policy?.aip_code && policy?.policy_number);
  };

  // --- --- ---

  const [isLoading, setIsLoading] = useState(false);

  const [policy, dispatchPolicy] = useReducer(propUpdateReducer, currentPolicy);

  const handleChangeState = (event, value) => {
    if ((!value || value === null) && event.target.value !== null) {
      value = event.target.value;
    }

    dispatchPolicy({
      type: "update",
      payload: { key: event.target.name, value: value },
    });
  };

  // --- --- ---

  const handleError = (err) => {
    console.warn(err);
    const errorMessage = getErrorMessage(err);
    enqueueSnackbar(errorMessage, { preventDuplicate: true, variant: "error" });
  };

  const handleSaveClick = async () => {
    try {
      const api = new ApiHelper({
        baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
        config: {},
        sessionManager: _sessionManager,
        _instance: null,
      });

      await api.callPost("ProducerPolicy", policy, globalState);
      onClose?.();
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <>
      <DialogTitle>Add Policy</DialogTitle>

      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth={true}>
              <StatefulControlledTextField
                label="AIP Code"
                name="aip_code"
                isRequired={true}
                defaultValue={policy.aip_code || ""}
                variant="outlined"
                inputProps={{ maxLength: 2 }}
                onChange={handleChangeState}
                InputLabelProps={{ shrink: true }}
                isLoading={isLoading}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth={true}>
              <StatefulControlledTextField
                label="Policy Number"
                name="policy_number"
                isRequired={true}
                defaultValue={policy.policy_number || ""}
                variant="outlined"
                onChange={handleChangeState}
                InputLabelProps={{ shrink: true }}
                isLoading={isLoading}
              />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="flex-end">
          <Button variant="contained" color="secondary" autoFocus onClick={onClose}>
            <CloseOutlined sx={{ mr: 1 }} />
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSaveClick} disabled={!isValid()}>
            <SaveOutlined sx={{ mr: 1 }} />
            Save
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};
